import { Routes } from '@angular/router';
import { appRouteConstants } from './app.route.constants';
import { LoginComponent } from './components/authentication/login/login.component';
import { AuthenticationGuard } from './components/authentication/guard';
import { Role } from 'portalServices';
import { ResetPasswordReqComponent } from './components/authentication/reset-request/reset-password-request.component';
import { ResetPasswordComponent } from './components/authentication/reset/reset.-password.component';

export const createCleanRoute: Function = (name: string) => name.toLowerCase().replace(/ /g, "-").replace(/\//g, "-");

export const routes: Routes = [
    {
        path: appRouteConstants.AUTH.LOGIN,
        component: LoginComponent,
        pathMatch: 'full'
    },
    {
        path: appRouteConstants.AUTH.RESET_REQUEST,
        component: ResetPasswordReqComponent,
        pathMatch: 'full'
    },
    {
        path: appRouteConstants.AUTH.RESET,
        component: ResetPasswordComponent,
        pathMatch: 'full'
    },
    {
        path: 'join',
        loadChildren: () => import('./components/joining-form/joining-form.module').then(m => m.JoiningFormModule)
    },
    {
        canActivate: [AuthenticationGuard],
        path: 'hr',
        loadChildren: () => import('./components/main-component.module').then(m => m.MainComponentModule),
        data: {
            roles: [
                Role.Admin,
                Role.Contracts,
                Role.Payroll,
                Role.Hr,
                Role.SalesRep,
                Role.Sales,
                Role.BenchSales,
                Role.LeadRep,
                Role.ExternalTimeApproval,
                Role.HMManager,
                Role.HMUser,
                Role.ReportingManager,
                Role.SettingsAdmin
            ]
        }
    },
    {
        canActivate: [AuthenticationGuard],
        path: '',
        loadChildren: () => import('./components/main-component.module').then(m => m.MainComponentModule),
        data: {
            roles: [
                Role.Admin,
                Role.Contracts,
                Role.Payroll,
                Role.Hr,
                Role.SalesRep,
                Role.Sales,
                Role.BenchSales,
                Role.LeadRep,
                Role.ExternalTimeApproval,
                Role.HMManager,
                Role.HMUser,
                Role.ReportingManager,
                Role.SettingsAdmin
            ]
        }
    }
];